var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapseIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30454",
    "data-name": "Group 30454",
    transform: "translate(-442 -1978.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30214",
    "data-name": "Group 30214",
    transform: "translate(403 1961.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28004",
    "data-name": "Group 28004",
    transform: "translate(39 17)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4109",
    "data-name": "Rectangle 4109",
    fill: "#fff",
    stroke: "#d5d5d5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19488",
    "data-name": "Group 19488",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4110",
    "data-name": "Rectangle 4110",
    width: 18,
    height: 18,
    rx: 3,
    fill: "#4dad46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9947",
    "data-name": "Path 9947",
    d: "M3525.646,217.009l2.777,2.35,6.957-7.587",
    transform: "translate(-3521.424 -206.561)",
    fill: "none",
    stroke: "#EB1700",
    strokeLinecap: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1062",
    "data-name": "Line 1062",
    x2: 7,
    transform: "translate(44.5 26.195)",
    fill: "none",
    stroke: "#EB1700",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7928",
    "data-name": "Rectangle 7928",
    transform: "translate(442 1978.305)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 2,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIconNew);
export default __webpack_public_path__ + "static/media/collapseIcon-new.4997d5b65d6ce4d363152107159eaa95.svg";
export { ForwardRef as ReactComponent };